import cx from "classnames";
import { FlexBox, Card, StatusMark, Image } from "components";
import React, { useState } from "react";
import "./styles.scss";
import { CodeProps } from "./types";
//Assets
import CopyIcon from "assets/icons/copy.png";
//Utils
import { copyText } from "utils";

const Code: React.FC<CodeProps> = ({
  className,
  title,
  code,
  codeToBeCopied,
}) => {
  return (
    <Card className={cx("pd-0 docs-code-block", className)}>
      <FlexBox justifyBetween alignCenter className="pd-v-10 pd-h-20 fs-16">
        {title}
        {/* <Dropdown
          title=""
          list={requestLanguage}
          callback={setActiveRequestLanguage}
          defaultValue={activeRequestLanguage}
        /> */}
      </FlexBox>
      <div
        className="code clr-white fs-14 word-break"
        onClick={() => {
          codeToBeCopied && copyText(codeToBeCopied);
        }}
      >
        {codeToBeCopied && (
          <FlexBox justifyEnd>
            <Image src={CopyIcon} className="copy-img clicking-animation" />
          </FlexBox>
        )}
        <div className="mr-t-5">{code}</div>
      </div>
    </Card>
  );
};
export default Code;
